import { Texture } from '@babylonjs/core/pure';
import type { Scene, StandardMaterial } from '@babylonjs/core/pure';

/** Reuse an authored atlas cell so individual vehicle puffs have soft alpha edges. */
export function textureSmoke(material: StandardMaterial, scene: Scene): void {
  if (scene.getEngine().getClassName() === 'NullEngine') return;
  const texture = new Texture('assets/fx-smoke.png', scene, false, false, Texture.TRILINEAR_SAMPLINGMODE);
  texture.hasAlpha = true;
  texture.uScale = texture.vScale = .5;
  texture.vOffset = .5;
  texture.wrapU = texture.wrapV = Texture.CLAMP_ADDRESSMODE;
  material.diffuseTexture = texture;
  material.useAlphaFromDiffuseTexture = true;
}
